import { FieldsStep } from '../steps/FieldsStep';

/**
 * Step 5, Vocabulary: Keywords, Always say, Never say, Social hashtags and Catchphrases and slogans,
 * stacked (spec:255), each a tag cloud with its own colour and source tags. Social hashtags keep their
 * `#` rule.
 */
export function VocabularyStep({ disabled = false }: { disabled?: boolean }) {
  return <FieldsStep step={5} disabled={disabled} />;
}
